// helpers.js

export const generateBillText = (
  row,
  selectedHostel,
  billMonth
) => {

  const isMess =
    row.serviceType === "mess" ||
    row.serviceType === "both";

  const isStay =
    row.serviceType === "stay" ||
    row.serviceType === "both";


  const serviceLabel =
    row.serviceType === "mess"
      ? "MESS"
      : row.serviceType === "stay"
      ? "STAY"
      : "STAY + MESS";


  return `
HOSTEL & PG GUEST BILL
================================

Property     : ${selectedHostel || "-"}

Bill Month   : ${billMonth || "-"}

Bill Date    : ${row.date || "-"}


Guest Name   : ${row.name || "-"}

Mobile       : ${row.customerMobileNumber || "-"}

Address      : ${row.address || "-"}

Service      : ${serviceLabel}



${
  isStay
    ? `
--------------------------------
STAY DETAILS
--------------------------------

Room Type    : ${row.roomType || "-"}

Room No      : ${row.roomNumber || "-"}

Check-In     : ${row.checkIn || "-"}

Check-Out    : ${row.checkOut || "-"}

Stay Rent    : ₹${Number(row.stayRate || 0).toFixed(2)}

`
    : ""
}



${
  isMess
    ? `
--------------------------------
MESS DETAILS
--------------------------------

From Date    : ${row.checkIn || "-"}

To Date      : ${row.checkOut || "-"}

Mess Days    : ${row.stayDays || 1}

Persons      : ${row.count || 1}

Rate/Day     : ₹${Number(row.rate || 0).toFixed(2)}

Mess Charge  : ₹${Number(row.messTotal || 0).toFixed(2)}

`
    : ""
}



--------------------------------
PAYMENT SUMMARY
--------------------------------

Discount     : ₹${Number(row.discount || 0).toFixed(2)}

Total Bill   : ₹${Number(
  row.finalBill ?? row.total ?? 0
).toFixed(2)}

Received     : ₹${Number(row.received || 0).toFixed(2)}

Balance      : ₹${Number(row.balance || 0).toFixed(2)}



================================

Thank You For Visiting

Website : https://hostelandpg.com

`;
};



/* ===============================
      PRINT BILL
================================ */

export const printBill = (billText) => {

  const content = billText.replace(
    /\n/g,
    "<br/>"
  );


  const win = window.open(
    "",
    "",
    "width=800,height=600"
  );


  win.document.write(`
    <html>

    <head>

    <title>
    Guest Bill
    </title>


    <style>

    body{
      font-family:Arial;
      padding:20px;
      line-height:1.6;
    }

    </style>


    </head>


    <body>

    ${content}


    </body>

    </html>
  `);


  win.document.close();

  win.print();

};



/* ===============================
      WHATSAPP BILL
================================ */

export const sendWhatsAppBill = (
  phoneNumber,
  billText
) => {

  const url =
    `https://wa.me/91${phoneNumber}?text=${encodeURIComponent(
      billText
    )}`;


  window.open(
    url,
    "_blank"
  );

};




/* ===============================
      STATUS
================================ */

export const statusColor = (status) => {

  if(
    status === "paid" ||
    status === "completed"
  )
    return "success";


  if(
    status === "partial" ||
    status === "partially_completed"
  )
    return "warning";


  return "default";

};



export const statusLabel = (status)=>{

  if(status==="paid")
    return "Completed";


  if(status==="partial")
    return "Partial";


  return "Pending";

};




/* ===============================
      TOTALS
================================ */


export const totalAmount = (rows)=>{

 return rows.reduce(
   (sum,row)=>
    sum + Number(row.total || 0),
    0
 );

};



export const totalReceived = (rows)=>{

 return rows.reduce(
   (sum,row)=>
    sum + Number(row.received || 0),
    0
 );

};



export const totalBalance = (rows)=>{

 return totalAmount(rows)
        -
        totalReceived(rows);

};